export const ARCurrency = new Intl.NumberFormat('es-AR');

export const IntlNumberFormat = (
  value: number | string = 0,
  symbol = '$',
  config?: Intl.NumberFormatOptions,
  locale = 'es-AR'
) => {
  const numberToFormat = Number(value) || 0;
  const fractionDigits = numberToFormat === 0 ? 0 : 2;

  const formattedNumber = new Intl.NumberFormat(locale, {
    currency: 'ARS',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    ...config
  }).format(numberToFormat);

  return `${symbol}${formattedNumber}`;
};
